// extracted by mini-css-extract-plugin
export default {"chartContainer":"CryptoChart_chartContainer__GjEMN"};